import { CSSProperties } from 'react';

export type IconeDecorativo = {
  src: string;
  tamanho: number;
  /** Posição e rotação, como no Galeria.dc.html. */
  estilo: CSSProperties;
};

type CamadaDecorativaProps = {
  icones: IconeDecorativo[];
  /** Opacidade da camada: 0.18 no hero, 0.3 no cartão de ciclo. */
  opacidade: number;
  /**
   * Achata os ícones em branco. Vale sobre o azul do hero, onde as
   * ilustrações cinza do design system virariam manchas escuras; sobre o
   * cinza claro do cartão de ciclo elas já leem como textura.
   */
  emBranco?: boolean;
};

export default function CamadaDecorativa({ icones, opacidade, emBranco }: CamadaDecorativaProps) {
  return (
    <div
      aria-hidden="true"
      className={`pointer-events-none absolute inset-0 ${emBranco ? '[&_img]:brightness-0 [&_img]:invert' : ''}`}
      style={{ opacity: opacidade }}
    >
      {icones.map(({ src, tamanho, estilo }) => (
        <img key={src} src={src} alt="" width={tamanho} height={tamanho} className="absolute" style={estilo} />
      ))}
    </div>
  );
}
